import { combineLatest, MonoTypeOperatorFunction, Observable } from 'rxjs';
import { map, filter } from 'rxjs/operators';

export function pauseResumeOperator<TModel>(pauseResume$: Observable<boolean>): MonoTypeOperatorFunction<TModel> {
  return (obs$) =>
    combineLatest([obs$, pauseResume$]).pipe(
      filter(([, pauseResume]) => pauseResume),
      map(([obs]) => obs),
    );
}
